import config from '@platform/shared/config';
import { UserStore } from '@platform/store';
import { DataType, NodeAPI } from '@platform/shared/rpc';

export async function sysGetMetadataField(params: any) {
    try {
        const query_response = await NodeAPI.Rpc.callFunction({
            fn: 'platform.sys_get_metadata_field',
            args: {
                sys_service_id_in: { type: 'uuid', value: config.serviceId },
                sys_org_id_in: { type: 'uuid', value: UserStore.userState.sysParams.sysOrgId },
                sys_metadata_id_in: { type: 'uuid', value: params?.sys_metadata_id },
                field_type_sql_in: { type: 'varchar', value: params?.field_type_sql ?? null },
            },
            struct: {
                id: { dataType: DataType.UUID },
                name: { dataType: DataType.VARCHAR },
                field_name: { dataType: DataType.VARCHAR },
                sys_metadata_id: { dataType: DataType.UUID, ref: 'platform.sys_metadata' },
            },
            options: {
                withViewedInfo: false,
                withFilesInfo: false,
                legacy: true,
            },
        });

        if (params?.forSelectField) {
            const rowData: any[] = [];
            query_response?.forEach?.((item: any) => {
                rowData.push({
                    name: item?.name,
                    label: item?.name,
                    value: item?.id,
                    field_name: item?.field_name,
                });
            });

            return rowData.sort(function (a, b) {
                if (a.name > b.name) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                return 0;
            });
        }

        return query_response;
    } catch (e) {
        console.warn(e);
    }
}

export async function readMetadataField(params: any) {
    try {
        const query_response = await NodeAPI.Rpc.readWithRefs(
            {
                tableInfo: { schemaName: 'platform', tableName: 'sys_metadata_field' },
                struct: {
                    id: { dataType: DataType.UUID },
                    name: { dataType: DataType.VARCHAR },
                    field_name: { dataType: DataType.VARCHAR },
                    sys_row_status: { dataType: DataType.VARCHAR },
                    sys_metadata_id: { dataType: DataType.UUID, ref: 'platform.sys_metadata' },
                    sys_service_org_link_id: { dataType: DataType.UUID },
                },
            },
            {
                withViewedInfo: false,
                withFilesInfo: false,
                legacy: true,
                filters: params?.filters,
            }
        );

        if (params?.forSelectField) {
            const rowData: any[] = [];
            query_response?.forEach?.((item: any) => {
                rowData.push({
                    name: item?.name,
                    label: item?.name,
                    value: item?.id,
                    field_name: item?.field_name,
                });
            });

            return rowData.sort(function (a, b) {
                if (a.name > b.name) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                return 0;
            });
        }

        return query_response;
    } catch (e) {
        console.warn(e);
    }
}
